import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { BiSearchAlt2, BiUser } from 'react-icons/bi';
import { FaAngleDown, FaFilter } from 'react-icons/fa';
import { ImLocation } from 'react-icons/im';
import { MdBusiness } from 'react-icons/md';
import { RxCross2 } from 'react-icons/rx';
import { useSelector } from 'react-redux';
import { allLanguagesArray } from '../../constant/commonData';
import { getWindowWidth } from '../../CustomHooks/isMobileViewHook';
import AgentsMoreFiltersModal from '../../modals/AgentsMoreFiltersModal';
import Button from '../Button/Button';
import CustomOverlay from '../CustomOverlay';
import LocationFiltersOverlay from '../LocationFilterOverlay';
import MapMain from '../maps/MapMain';
import classes from './agentAndCompanyFilters.module.css';

const FilterDiv = ({ text, icon, iconRight, ...props }) => {
  return (
    <div className={classes.dropdownBox} {...props}>
      <div>
        {icon} <span className="maxLine1">{text}</span>
      </div>
      {iconRight || <FaAngleDown className={classes.icon} color="#484848" />}
    </div>
  );
};

const LanguagesOverlay = ({ handleClick, applyFilters, mainData, show, target, t }) => {
  const { selectedLanguage } = useSelector((state) => state?.languageReducer);

  let langText = mainData?.languages
    ?.slice(0, 5) // Only first 5 languages
    .map((item) => item[selectedLanguage])
    .join(', ');

  if (mainData?.languages?.length > 5) {
    langText += '...';
  }

  return (
    <CustomOverlay
      show={show == 'languages'}
      target={target}
      handleClose={(e) => handleClick('', e)}
      targetElement={
        <FilterDiv
          {...(langText && {
            iconRight: (
              <RxCross2
                onClick={() => {
                  applyFilters({ languages: [] });
                }}
              />
            )
          })}
          onClick={(e) => {
            handleClick(e, 'languages');
          }}
          text={langText || t('filters.languages')}
        />
      }>
      <div className={[classes.overlayBox, classes.p0].join(' ')}>
        <ul className={classes.listOptionsWithBrBtm}>
          {allLanguagesArray?.map((item, key) => (
            <button
              key={key?.toString()}
              className="btnWrapper100"
              onClick={() => {
                const index = mainData?.languages?.findIndex((e) => e?.en == item?.en);
                if (index == -1) {
                  applyFilters({ languages: [...mainData.languages, item] });
                } else {
                  applyFilters({
                    languages: mainData.languages?.filter((e) => e?.en !== item?.en)
                  });
                }
              }}>
              <li data-selected={mainData?.languages?.find((e) => e?.en == item?.en) && true}>
                {item?.[selectedLanguage]}
              </li>
            </button>
          ))}
        </ul>
      </div>
    </CustomOverlay>
  );
};
function AgentAndCompanyFilters({
  onSearch,
  hideTabs,
  containerClass = '',
  filtersWrapperClass = '',
  selectedTab,
  setSelectedTab,
  filters,
  setFilters,
  searchText,
  setSearchText,
  t
}) {
  const tabsData = [
    { id: 1, text: t('filters.companies'), value: 'company', icon: <MdBusiness /> },
    { id: 2, text: t('filters.agent'), value: 'agents', icon: <BiUser /> }
  ];

  // For Popover
  const [show, setShow] = useState('');
  const [target, setTarget] = useState(null);

  // For Modal States
  const [screenWidth, setScreenWidth] = useState('');
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    getWindowWidth(setScreenWidth);
  }, []);
  const handleClick = (event, type) => {
    setShow(type || '');

    if (event) {
      setTarget(event.target);
    } else {
      setTarget(null);
    }
  };

  const handleSearch = () => {
    onSearch?.();
  };

  return (
    <Container className={`${containerClass}`}>
      {!hideTabs && (
        <ul className={classes.tabs}>
          {tabsData?.map((item, key) => (
            <button
              className="btnWrapper100"
              key={key?.toString()}
              onClick={() => {
                setSelectedTab(item?.value);
              }}>
              <li data-selected={item?.value == selectedTab}>
                <p>{item?.text}</p>
              </li>
            </button>
          ))}
        </ul>
      )}
      <div className={[classes.otherOptions, filtersWrapperClass].join(' ')}>
        <Row className={`${classes.row} gx-0`}>
          {screenWidth > 992 && (
            <Col md={3} className={classes.width170}>
              <LocationDropDown
                show={show}
                target={target}
                handleClick={handleClick}
                filters={filters}
                setFilters={setFilters}
                setShow={setShow}
                t={t}
              />
            </Col>
          )}
          <Col md={4}>
            <MapMain
              setCoordinates={(e) => {
                setFilters((prev) => ({ ...prev, lng: e?.lng, lat: e?.lat }));
              }}
              onBlurCapture={(e, value, setValue) => {
                if (value && !filters?.lng && !filters?.lat) {
                  setValue('');
                }
              }}
              address={searchText}
              setAddress={(e) => {
                setSearchText(e);
                setFilters((prev) => ({
                  ...prev,
                  nearby: false,
                  province: null,
                  town: null,
                  neighborhood: null
                }));
              }}
              placeholder={t('filters.search')}
              type="places"
              comboRootClassName={classes?.searchInput}
              deleteIcon
            />
          </Col>
          {screenWidth > 992 && (
            <Col md={3} className={classes.width170}>
              <LanguagesOverlay
                mainData={filters}
                show={show}
                applyFilters={(e) => setFilters((prev) => ({ ...prev, ...e }))}
                handleClick={handleClick}
                target={target}
                t={t}
              />
            </Col>
          )}
          {screenWidth < 992 && (
            <Col md={3} className={classes.width170}>
              <FilterDiv
                onClick={() => {
                  setShowModal(true);
                }}
                iconRight={screenWidth <= 600 ? false : <FaFilter className={classes.icon} />}
                text={
                  screenWidth <= 600 ? <FaFilter className={classes.icon} /> : t('filters.title')
                }
              />
            </Col>
          )}
          <Col md={2} className={classes.searchBtnCol}>
            <Button
              variant="secondary"
              borderRadius={'3px'}
              onClick={handleSearch}
              className={classes.searchBtn}>
              {screenWidth <= 600 ? (
                <BiSearchAlt2 color="var(--white-clr)" />
              ) : (
                t('filters.searchBtn')
              )}
            </Button>
          </Col>
          {screenWidth < 992 && (
            <AgentsMoreFiltersModal show={showModal} setShow={setShowModal} onApply={onSearch}>
              <Col md={12}>
                <LanguagesOverlay
                  mainData={filters}
                  show={show}
                  applyFilters={(e) => setFilters((prev) => ({ ...prev, ...e }))}
                  handleClick={handleClick}
                  target={target}
                  t={t}
                />
              </Col>
              <Col md={12}>
                <LocationDropDown
                  show={show}
                  target={target}
                  handleClick={handleClick}
                  filters={filters}
                  setFilters={setFilters}
                  setShow={setShow}
                  t={t}
                />
              </Col>
            </AgentsMoreFiltersModal>
          )}
        </Row>
      </div>
    </Container>
  );
}

export default AgentAndCompanyFilters;

const LocationDropDown = ({ show, target, handleClick, filters, setFilters, setShow, t }) => (
  <CustomOverlay
    show={show == 'location'}
    target={target}
    handleClose={(e) => handleClick('', e)}
    targetElement={
      <FilterDiv
        onClick={(e) => handleClick(e, 'location')}
        icon={<ImLocation color={'var(--secondary-clr)'} />}
        text={t('filters.location')}
      />
    }>
    <div className={classes.overlayBox}>
      <LocationFiltersOverlay
        locationState={filters}
        setLocationState={setFilters}
        setClose={setShow}
      />
    </div>
  </CustomOverlay>
);
